import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { MUTATION_TYPE } from "hooks";
import { UPDATE_LEGACY_TERM_SHEET } from "graphql/mutations";
import { MODAL_SIZE, ModalForm } from "components/Modal";
import { SIZE, TYPE } from "components/Form";

/**
 * RenameLegacyTermSheetModal
 *
 * @param {Boolean}   show
 * @param {String}    name
 * @param {String}    versionId
 * @param {Function}  onComplete
 * @param {Function}  onClose
 */
const RenameLegacyTermSheetModal = ({ show, name, versionId, onComplete, onClose }) => {
  const formProps = {
    initialValues: { name },
    mutationType: MUTATION_TYPE.update,
    updateId: versionId,
    mutationData: {
      mutationName: {
        update: UPDATE_LEGACY_TERM_SHEET,
      },
    },
  };

  return (
    <ModalForm
      show={show}
      size={MODAL_SIZE.small}
      data={FORM_DATA({ name })}
      title={<FormattedMessage id="TermSheets.LegacyTermSheetTable.RenameTermSheetModal.Title" />}
      onCompleted={onComplete}
      onClose={onClose}
      {...formProps}
    />
  );
};

const FORM_DATA = ({ name }) => [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        label: "Name",
        type: TYPE.input,
        size: SIZE.xlarge,
        properties: {
          name: "name",
          type: "text",
          required: true,
          autoFocus: true,
          placeholder: "Name of Term Sheet",
          defaultValue: name,
        },
      },
    ],
  },
];

RenameLegacyTermSheetModal.propTypes = {
  show: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  versionId: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RenameLegacyTermSheetModal;
